export const AVA_ORB_IMAGE_PATH = "/ava/ava_orb_idle_512.png";
